import type { BlockType } from '@unifyapps/defs/types/block';

export function getNeoMorphicStyles(block: BlockType) {
  if (!block.additional?.customCSS) return undefined;
  const customCSS = JSON.parse(block.additional.customCSS) as Record<string, unknown> | undefined;
  console.log(customCSS);
  if (!customCSS) {
    return undefined;
  }

  const { neoMorphicStyles } = customCSS;
  return neoMorphicStyles;
}
